export default "__VITE_ASSET__CLW4Cs_p__"